import { FC } from "react";
import { HEADER_DEFAULTS, THeaderProps } from "./Header.config";
import { Container } from "../../layout";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderMenu } from "./HeaderMenu";
import { HeaderActions } from "./HeaderActions";

export const Header: FC<THeaderProps> = ({
  actions,
  menu,
  "data-component": component = HEADER_DEFAULTS["data-component"],
}) => (
  <header data-component={component} className="sticky top-0 bg-sys-white z-30">
    <Container className="relative h-16 flex justify-between items-center" size="md">
      <HeaderActions primary={actions?.primary} />
      <HeaderLogo />
      <HeaderMenu items={menu?.items} />
    </Container>
  </header>
);
